'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { GraduationCap, Building2, Megaphone, TrendingUp } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const goals = [
{
  icon: <GraduationCap size={28} className="text-[#4caf7d]" />,
  title: 'Giá trị cho sinh viên',
  items: ['Kỹ năng thực tế được rèn luyện', 'Nội dung cá nhân có thể chia sẻ', 'Chứng nhận Green Warrior có giá trị'],
  accent: '#4caf7d'
},
{
  icon: <Building2 size={28} className="text-[#e8a030]" />,
  title: 'Lợi ích cho nhà trường',
  items: ['Chương trình bài bản, sẵn sàng triển khai', 'Không cần đầu tư cơ sở hạ tầng', 'Dễ báo cáo & đo lường kết quả'],
  accent: '#e8a030'
},
{
  icon: <Megaphone size={28} className="text-[#a8d87a]" />,
  title: 'Dễ truyền thông & lan tỏa',
  items: ['Nội dung thật — cảm xúc thật', 'Sinh viên tự tạo và chia sẻ', 'Viral tự nhiên trên mạng xã hội'],
  accent: '#a8d87a'
},
{
  icon: <TrendingUp size={28} className="text-[#f5c96a]" />,
  title: 'Có thể phát triển lâu dài',
  items: ['Mô hình nhân rộng nhiều trường', 'Mỗi mùa một chủ đề mới', 'Xây dựng cộng đồng Green Warriors'],
  accent: '#f5c96a'
}];


export default function Slide06Goals({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_171aa2e57-1774901432383.png"
          alt="Nhóm tình nguyện viên sinh viên cùng nhau làm việc ngoài trời, thể hiện tinh thần đoàn kết và đóng góp cộng đồng"
          className="w-full h-full object-cover opacity-8" />

        <div className="absolute inset-0 bg-gradient-to-b from-[#0f2318] to-[#1a3a2a]/30" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[rgba(76,175,125,0.04)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">Mục tiêu chương trình</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Chương trình tạo ra
          </h2>
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] tracking-tight text-gradient-green">
            giá trị cho ai?
          </h2>
        </div>

        <div className="fade-in-up mb-12">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 fade-in-up">
          {goals.map((goal, i) =>
          <div
            key={`goal-${i}`}
            className="rounded-2xl p-6 lg:p-7 bg-[rgba(26,58,42,0.5)] border border-[rgba(76,175,125,0.15)] flex flex-col transition-all duration-300 hover:-translate-y-1"
            style={{ borderTopColor: `${goal.accent}40` }}>

              <div
              className="p-3 rounded-xl inline-flex mb-5 w-fit"
              style={{ background: `${goal.accent}18`, border: `1px solid ${goal.accent}25` }}>

                {goal.icon}
              </div>
              <h3 className="font-display font-700 text-[16px] lg:text-[17px] text-[#f0ede6] mb-4">
                {goal.title}
              </h3>
              <ul className="space-y-2.5 flex-1">
                {goal.items.map((item) =>
              <li key={`goal-item-${item}`} className="flex items-start gap-2.5">
                    <span
                  className="w-1.5 h-1.5 rounded-full flex-shrink-0 mt-2"
                  style={{ background: goal.accent }} />

                    <span className="font-body text-[13px] lg:text-[14px] text-[#a0b8a8] leading-relaxed">{item}</span>
                  </li>
              )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </SlideWrapper>);

}